import companyAxios from './company-axios.js';
const companyApi = {
    getToken: function() {
        console.log('company-api get token', companyAxios);
    },
    get: function(url) {
        return companyAxios.get('https://id.magico.pro/' + url);
    },
    getMe: function() {
        return companyAxios.get('https://id.magico.pro/api/v1/authorize/me');
    }
};
export default companyApi;